import { render, staticRenderFns } from "./ArticleFooter.vue?vue&type=template&id=194b8dca&"
import script from "./ArticleFooter.vue?vue&type=script&lang=ts&"
export * from "./ArticleFooter.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports